import defaultsDeep from 'defaults-deep-ts';
import { factory } from '../factories';
export function orderSanitizer(orderProto) {
  const defaultOrder = factory.entities.order();
  return defaultsDeep(orderProto, defaultOrder);
}
//# sourceMappingURL=order.js.map